import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Offer } from '../../../../models/Offer';
import { BaseHttpService } from 'src/app/services/base-http/base-http.service';
import { OffersService } from '../../../../services/offers/offers.service';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../services/languages/language.service';

@Component({
  selector: 'app-offer-preview',
  templateUrl: './offer-preview.component.html',
  styleUrls: ['./offer-preview.component.scss'],
})
export class OfferPreviewComponent implements OnInit {
  @Input() offer: Offer;
  noImageAvailableUrl = 'src/assets/images/no-images-available.jpg';
  lang: string;

  constructor(
    public httpService: BaseHttpService,
    public router: Router,
    public offerService: OffersService,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    this.languageService.currentLanguageKey.subscribe((val: string) => {
      this.lang = val;
    });
  }

  @HostListener('click') clickOnSeeMore(): void {
    this.router.navigate([this.lang + '/offer/' + this.offer.id.toString()]);
  }

  navigate($ev) {
    $ev.preventDefault();
    this.router.navigate([this.lang + '/offer/' + this.offer.id.toString()]);
  }
}
